import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { twMerge } from 'tailwind-merge';

interface ClickableLineItemProps extends Omit<ComponentPropsWithoutRef<'button'>, 'color'> {}

const ClickableLineItem = (props: ClickableLineItemProps) => {
    const { onClick, className = '', ...rest } = props;

    return (
        <Button
            variant="none"
            onClick={onClick}
            className={twMerge(
                'w-full gap-4 rounded-md pr-2 text-left font-medium hover:bg-gray-100',
                className,
            )}
            {...rest}
        />
    );
};

export { ClickableLineItem };
